module.exports = "<svg class=\"sv-svg-icon\"><use></use></svg>\n";